import { EyeIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Eye = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <EyeIcon color={fill} {...rest} size={Sizes[size]} />;
};

Eye.displayName = 'Eye';
